import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import * as appConstants from "../../../constants/index";
import ExtendTime from "src/views/common/extend-time/ExtendTime";
import cancelTicket from "../../../assets/food/cancel-ticket.svg";
import miv_inox from "../../../assets/default-images/vertical-poster-inox.svg";
import miv_pvr from "../../../assets/default-images/vertical-poster-pvr.svg";
import cinemaScreen from "../../../assets/food/cinema-seat.svg";
import noSack from "../../../assets/food/no-snack.svg";
import priceArrow from "../../../assets/food/price-arrow.svg";
import nonveg from "../../../assets/food/nonveg.svg";
import veg_icon from "../../../assets/food/veg-icon.svg";
import BookingSummarySkeleton from "src/skeletons/BookingSummarySkeleton";
import { setViewMode as setviewmodeup } from "src/redux/actions/viewModeActions";
import fastFood from "../../../assets/seatlayout/fastfood.svg";
import peplaceholer from "../../../assets/seatlayout/promote-earn-placeholder.svg";
import superticketlogo from "../../../assets/super-ticket/SUPER-TICKET.png";
import superticketlogonew from "../../../assets/super-ticket/super-ticket-sticker.png";
import geminifill from "../../../assets/super-ticket/gemini-fill.png";
import staricon from "../../../assets/family/staricon.svg";
import info from "../../../assets/super-ticket/info.png";
import activity from "../../../assets/seatlayout/activity.svg";
import { DarkButton, LightButton } from "src/styled-components/customButtons";
import { Dialog } from "primereact/dialog";
import "./ticketsummary.css";
import "../../seat-layout/seatlayout.css";
import { handleMivImageError } from "src/global-functions/imageErrorSrc";
import { Link, useNavigate } from "react-router-dom";
import { FaRupeeSign, FaChevronUp } from "react-icons/fa";
import { setGrandTotalamount } from "src/redux/actions/gradTotalAction";
import { useDispatch, useSelector } from "react-redux";
import PasssportSummary from "./PasssportSummary";
import FlexiPayPopup from "../flexipay/FlexiPayPopup";
// import SuperTicketPopup from "src/views/superticket/SuperticketPopup";
import FlexiTnc from "../flexipay/FlexiTnc";
import FlexiHowItWork from "../flexipay/FlexiHowItWork";
import OnTime from "../../../assets/flexi/FLEXISHOW-LOGO-WHITE.svg";
import InfoFlexi from "../../../assets/flexi/info.svg";
import Tick from "../../../assets/flexi/tick.svg";
import RightArrow from "../../../assets/images/rightarrow.svg";
import FlexiHowTouse from "../flexipay/FlexiHowTouse";
//import FamilyBundle from "../family-bundle/FamilyBundle";
import FamilyBundle from "../family-bundle/Familybundlenew";
import { familyBundleRemove } from "src/services/CouponPayment";
import SuperTicketHowItWork from "src/views/superticket/SuperticketHowtowork";
import SuperTicketTnc from "src/views/superticket/SuperticketTnc";
import { postDataService } from "src/services/postApiService";
import swal from "sweetalert";
import unlock from "../../../assets/super-ticket/unlock.png";
import SweetAlert from 'react-bootstrap-sweetalert';
import SuperTicketRules from "src/views/superticket/SuperticketRules";
import superticketReducer from "src/redux/reducers/SuperticketReducer"
import { IsEvent } from "src/global-functions/globalFunctions";
import { Checkbox } from "primereact/checkbox";


const TicketSummary = ({ discount, ticketSummaryData, removeApply, applyData, checked,
  setChecked }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = localStorage.getItem("theme");
  // const [checked, setChecked] = useState(false);
  const token = sessionStorage.getItem("token");
  const isMobile = window.matchMedia("(max-width: 575px)").matches;
  const [ticketSummary, setTicketSummary] = useState(null);
  const [discountData, setdiscountData] = useState(null);
  const [showPopup, setShowPopup] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showConvFee, setShowConvFee] = useState(false);
  const [donationPrice, setDonationPrice] = useState(0);
  const [donation, setDonation] = useState(true);
  const [flexiVal, setFlexiVal] = useState(0);
  const [numofTicket, setNumofTicket] = useState(1);
  const [showAutoVoucher, setShowAutoVoucher] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [vouchersData, setAutoVouchersData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [passportSummary, setPassportSummary] = useState(null);
  const [showflexi, setShowflexi] = useState(false);
  const [showflexitnc, setShowflexiTnc] = useState(false);
  const [showsupertickettnc, setShowsupertickettnc] = useState(false);
  const [showflexihiw, setShowflexiHiw] = useState(false);
  const [ticketSummaryFb, setTicketSummaryFb] = useState(false);
  const [showflexihowitwork, setShowflexiHowitwork] = useState(false);
  const [showsupertickethowitwork, setShowsupertickethowitwork] = useState(false);
  const [familyBundle, setFamilyBundle] = useState(false);
  const [showsuperticket, setshowsuperticket] = useState(false);
  const [showunlockpopup, setShowunlockpopup] = useState(false);
  const [showsuperticketrules, setShowsuperticketrules] = useState(false);
  const [isSuperTicketAdded, setIsSuperTicketAdded] = useState();
  const [showsuper, setshowsuper] = useState();
  const isSuperTicketAddedRef = useRef(false);
  const showSuperTicketbox = useSelector((state) => state.superticketReducer.showSuperTicket);
  const loginInfo = JSON.parse(sessionStorage.getItem("loginInfo") || "null");
  const fbqFired = useRef(false);
  const [showTnC, setShowTnC] = useState(false);


  const HtmlRenderer = ({ html }) => {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };



  const onloadpushToDataLayer = (event, voucherName, voucherId, price, validDate) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      voucher_name: voucherName,
      voucher_id: voucherId,
      price: price,
      valid_date: validDate
    });
  };

  useEffect(() => {
    if (ticketSummary && flexiVal == 0) {
      setShowPopup(false);
      if (showPopup) {
        if (ticketSummary?.familyBundleShow)
          setFamilyBundle(ticketSummary?.familyBundleShow);
        if (ticketSummary?.familyBundleVouchers?.length > 0) {
          const voucher = ticketSummary.familyBundleVouchers[0];
          onloadpushToDataLayer(
            "family_bundle_view",
            voucher.vouDesc,
            voucher.vouId,
            voucher.discValue,
            voucher.validity
          );
        }

        else setShowflexi(ticketSummary?.orderTicket?.flexiApplicable);
      }
    }
  }, [ticketSummary]);

  // Function to push event to dataLayer
  const pushToDataLayer = (event, voucherName, voucherId, price, validDate) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      voucher_name: voucherName,
      voucher_id: voucherId,
      price: price,
      valid_date: validDate
    });
  };


  useEffect(() => {
    if (!showsuper) {
      setshowsuperticket(true);
    }
  }, [setshowsuperticket, ticketSummary]);


  useEffect(() => {
    if (flexiVal > 0) {
      getTicketSummaryData(donation, false);
    }
  }, [flexiVal]);

  useEffect(() => {
    if (ticketSummaryFb) {
      getTicketSummaryData(donation, false);
    }
  }, [ticketSummaryFb]);


  useEffect(() => {
    if (showsuper) {
      getTicketSummaryData(donation, false);
    }
  }, [isSuperTicketAdded]);

  const removevoucher = async () => {
    removeApply();
  };
  const hitGa = (event) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
    });
  };
  const hitGaSuperTicket = (event, voucher_id) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      voucher_id: voucher_id
    });
  };

  const hitBeginCheckout = (ndt, tpvalue) => {
    const dataLayer = window.dataLayer || [];
    const totalAmount = Number(ndt.totalAmount.replace(/,/g, ""));
    const city = localStorage.getItem("city");
    const cinemaName = ndt?.orderFilmCinema?.theaterName || localStorage.getItem("cinema_name");
    const bookingType = localStorage.getItem("gatagbookingtype");
    const langGenreSeats = `${ndt?.orderFilmCinema?.language} / ${ndt?.orderFilmCinema?.genre} / ${ndt?.showTimeStr} / ${ndt?.orderTicket?.seats}`;
    const movieFormat = ndt?.orderTicket?.experience + "|" + ndt?.orderFilmCinema?.format;

    const items = [];
    // Movie item
    items.push({
      item_brand: ndt?.orderFilmCinema?.brand || "PVR",
      item_name: localStorage.getItem("filimname") || localStorage.getItem("movie_name"),
      item_id: localStorage.getItem("movieid"),
      item_list_name: ndt?.orderFilmCinema?.filmName,
      item_list_id: ndt?.orderFilmCinema?.filmId,
      item_category: "Movie",
      item_category2: bookingType,
      item_category3: getJourneyValue(ndt),
      item_category4: cinemaName,
      item_category5: langGenreSeats,
      price: Number(localStorage.getItem("seatPrice")),
      quantity: ndt?.orderTicket?.numOfSeats || 1,
      item_variant: movieFormat,
      location_id: city
    });

    // Food items
    ndt?.orderFood?.foods?.forEach(item => {
      items.push({
        item_brand: ndt?.orderFilmCinema?.brand || "PVR",
        item_name: item.name,
        item_id: item.itemId,
        item_category: "Food",
        item_category2: bookingType,
        item_category3: getJourneyValue(ndt),
        item_category4: cinemaName,
        item_category5: langGenreSeats,
        price: item.price / 100,
        quantity: item.quantity || 0,
        location_id: city
      });
    });

    dataLayer.push({
      event: "begin_checkout",
      ecommerce: {
        currency: "INR",
        value: totalAmount,
        journey_type: tpvalue,
        items
      }
    });
  };

  useEffect(() => {
    if (token && localStorage.getItem("removedonationamount")) {
      setDonation(false);
      getTicketSummaryData(false);
    } else {
      setDonation(true);
      getTicketSummaryData(true);
    }
  }, [token, localStorage.getItem("removedonationamount")]);


  useEffect(() => {
    if (discount) {
      let discountData = JSON.parse(discount);
      setdiscountData(discountData);
      dispatch(
        setGrandTotalamount({
          cutPrice: Number(
            discountData?.ft != discountData?.it
              ? Number(discountData?.it.replace(/,/g, ""))
              : 0
          ),
          finalPrice: discountData?.ft
            ? Number(discountData?.ft.replace(/,/g, ""))
            : 0,
        })
      );

      getTicketSummaryData(donation);
    }
  }, [discount, donation]);

  const Remove_bundle_hitGa = () => {
    if (ticketSummary?.familyBundle_data) {
      const voucher = ticketSummary.familyBundle_data;
      pushToDataLayer(
        "family_bundle_remove",
        voucher.voucherDesc,
        voucher.id,
        voucher.totalPrice,
        voucher.validity
      );

    }
  };

  const removeBundle = () => {
    Remove_bundle_hitGa();
    let postdata = {
      qr:
        localStorage.getItem("isQR") && isMobile
          ? "YES"
          : localStorage.getItem("fnb_qr") && isMobile
            ? "YES"
            : "NO",
      bookType: localStorage.getItem("booking_type"),
      transId: localStorage.getItem("transid"),
      bookingId: localStorage.getItem("bookingid"),
      ccode: localStorage.getItem("theaterId"),
      cvpId: ticketSummary?.familyBundle_data?.id,
      // quantity: currentValue - 1,
      // increment: currentValue - 1,
    };
    familyBundleRemove(postdata)
      .then((res) => {
        let data = res.data;
        // setFamilyBundle(false);
        getTicketSummaryData(donation, false);
        if (data?.output) {
        }
      })
      .catch((error) => {
        const err = error?.response;
        if (err?.status === 403) {
          // refraceTokenService();
          console.log(
            "Forbidden: You do not have permission to access this resource."
          );
        } else {
          console.log("Error:", error?.message);
        }
        // setLoading(false);
      });
  };

  function getJourneyValue(ndt) {
    if (ndt?.familyBundle_data?.voucherDesc) return "buy_family_offer";
    if (ndt?.cvp_data) return "buy_cvp";
    if (ndt?.superTicketData) return "buy_super_ticket";
    if (ndt?.flexiTotalTicketPrice > 0) return "buy_flexi_ticket";
    return "";
  }

  const getTicketSummaryData = async (donate, val = true) => {
    setLoading(true);
    const postData = {
      qr:
        localStorage.getItem("isQR") && isMobile
          ? "YES"
          : localStorage.getItem("fnb_qr") && isMobile
            ? "YES"
            : "NO",
      bookType: localStorage.getItem("booking_type"),
      transId: localStorage.getItem("transid"),
      bookingId: localStorage.getItem("bookingid"),
      ccode: localStorage.getItem("theaterId"),
      donate: localStorage.getItem("unpaidMode") === "true" ? false : donate,
      flexi: val ? 0 : flexiVal,
    };

    await axios
      .post(`${appConstants.base_url}v1/booking/ticketing/summary`, postData, {
        headers: {
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          Authorization: `Bearer ${token || ""}`,
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          const ndt = dt.output;
          setTicketSummary(ndt);
          localStorage.setItem('ticket_summary_alldata', JSON.stringify(ndt));
          setDonationPrice(ndt?.orderTicket?.donation);
          localStorage.setItem("grandVal", ndt?.finalAmount);
          dispatch(
            setGrandTotalamount({
              cutPrice: Number(
                ndt?.finalAmount != ndt?.totalAmount ? ndt?.totalAmount : 0
              ),
              finalPrice: Number(ndt?.finalAmount.replace(/,/g, "")),
            })
          );
          // console.log('ndt?.finalAmount', ndt?.finalAmount)
          setLoading(false);
          // console.log("ticketSummary==>", ndt);
          localStorage.setItem("quantity", ndt.orderTicket.numOfSeats);
          localStorage.setItem("price", ndt.totalAmount);
          if (ndt?.orderTicket?.flexiApply) {
            // setFlexiVal(1);
            dispatch(setviewmodeup(Math.floor(10000 + Math.random() * 90000)));
          }
          if (ndt?.familyBundle_data) {
            // setFlexiVal(1);
            dispatch(setviewmodeup(Math.floor(10000 + Math.random() * 90000)));
          }

          let journeyvalue = "";
          if (ndt?.bookType === "BOOKING" && ndt?.orderFood?.foodType && ndt.orderFood.foodType !== "") {
            journeyvalue = "Movie_Food";
          } else if (ndt?.bookType === "BOOKING") {
            journeyvalue = "Movie";
          } else if (bookingId) {
            journeyvalue = "Add_Food";
          } else if (localStorage.getItem("booking_type") === "FOOD") {
            journeyvalue = "Only_Food";
          } else {
            journeyvalue = "";
          }

          if (!isMobile) {
            hitBeginCheckout(ndt, journeyvalue);
          }

          ticketSummaryData(ndt);
          setshowsuper(true);
          hitGa("fnb_add_checkout");
          if (loginInfo !== null && !fbqFired.current) {
            fbq("track", "InitiateCheckout", {
              content_ids: localStorage.getItem("movieid"),
              content_name: localStorage.getItem("filimname"),
              content_type: "Movie",
              contents: localStorage.getItem("movie_name"),
              currency: "INR",
              Num_item: ndt?.orderTicket?.numOfSeats,
              value: ndt?.totalAmount,
            });

            fbqFired.current = true; // ✅ mark as fired
          }

          // IsEvent({
          //   action: "Product Added To Cart",
          //   user: {
          //     attributes: {
          //       lastAddedToCart: localStorage.getItem("movieid")|| "",
          //     },
          //   },
          // });
        }
        else {
          swal({
            text: dt?.msg,
            timer: 2500,
            buttons: false,
            icon: "error",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        const err = error?.response;
        if (err?.status === 403) {
          // refraceTokenService();
          console.log(
            "Forbidden: You do not have permission to access this resource."
          );
        } else {
          console.log("Error:", error?.message);
        }
        setLoading(false);
      });
  };
  const hitGaAPPLY = (event, voucher_id, valid_date, quantity, price) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      voucher_id: voucher_id,
      valid_date: valid_date,
      quantity: quantity,
      price: price

    });
  }

  const ApplySuperticket = async () => {
    setLoading(true);
    const bookingId = localStorage.getItem("bookingid");
    const transId = localStorage.getItem("transid");
    const isQR = localStorage.getItem("isQR");
    const fnbQR = localStorage.getItem("fnb_qr");
    const ccode = localStorage.getItem("theaterId");
    const city = localStorage.getItem("city");
    const token = sessionStorage.getItem("token") || "";
    const chain = theme === "inoxTheme" ? "INOX" : "PVR";
    const qr = (isQR && isMobile) || (fnbQR && isMobile) ? "YES" : "NO";
    const postData = {
      bookingId,
      transId,
      quantity: 0,
      qr,
      cvpId: ticketSummary?.superTicketVoucher?.vouId,
      increment: 0,
      ccode,
    };

    try {
      const response = await axios.post(
        `${appConstants.base_url}v1/booking/ticketing/sticket/apply`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            chain,
            city,
            appVersion: appConstants.av,
            platform: appConstants.pt,
          },
        }
      );

      const dt = response.data;
      if (dt?.result === "success") {
        hitGaAPPLY("super_ticket_add_to_cart",
          ticketSummary?.superTicketVoucher?.vouId,
          ticketSummary?.superTicketVoucher?.validity,
          Number(localStorage.getItem("quantity")), ticketSummary?.superTicketVoucher?.issueRate);

        setShowunlockpopup(true);
        setIsSuperTicketAdded(true);
        setshowsuperticket(false);
        setshowsuper(true);
        isSuperTicketAddedRef.current = true;
      } else if (dt?.result === "dialog") {
        swal({
          text: dt.msg,
          timer: 2500,
          buttons: false,
          icon: "error",
        });
      } else {
        swal({
          text: dt?.msg || "Unexpected response from server.",
          timer: 2500,
          buttons: false,
          icon: "warning",
        });
      }
    } catch (error) {
      const err = error?.response;
      if (err?.status === 403) {
        refraceTokenService();
        console.warn("403 Forbidden: Token may need refresh.");
      } else {
        console.error("API Error:", error?.message);
      }
    } finally {
      setLoading(false);
    }
  };


  const RemoveSuperticket = async () => {
    setLoading(true);
    const postData = {
      bookingId: localStorage.getItem("bookingid"),
      transId: localStorage.getItem("transid"),
      quantity: 0,
      qr: localStorage.getItem("isQR") && isMobile
        ? "YES"
        : localStorage.getItem("fnb_qr") && isMobile
          ? "YES"
          : "NO",
      cvpId: ticketSummary?.superTicketVoucher?.vouId,
      increment: 0,
      ccode: localStorage.getItem("theaterId"),
    };
    try {
      const data = await postDataService(`v1/booking/ticketing/sticket/remove`,
        postData
      );
      const dt = data;
      if (dt?.result === "success") {
        setshowsuper(true);
        setIsSuperTicketAdded(false);
        setshowsuperticket(false);
        setLoading(false);
        isSuperTicketAddedRef.current = false;
        swal({
          title: "Success",
          text: dt.msg,
          timer: 2500,
          icon: "success",
          buttons: false,
          //confirmButtonText: 'OK',
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching chain data:", error);

      setLoading(false);
    }
  };


  const hitCancelTicket = () => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "booking_now_with_ticket_cancellation",
      ecommerce: {
        items: [
          {
            item_brand: appConstants.cinemaChain, //(pvr/inox)
            item_name: localStorage.getItem("movie_name"),
            item_id: localStorage.getItem("movieid"),
            item_category: "ticket", //(selected ticket, gift card & passport)
            quantity: localStorage.getItem("quantity"),
            price: localStorage.getItem("seatPrice"),
          },
        ],
      },
    });
  };

  const calculateTotalPrice = () => {
    const bookingType = localStorage.getItem("booking_type");

    // Convert ticket price to a number
    const ticketPrice =
      (Number(ticketSummary?.orderTicket?.totalTicketPrice?.replace(/,/g, "")) || 0) +
      (Number(ticketSummary?.familyBundle_data?.discountPrice) || 0) +
      (Number(ticketSummary?.orderTicket?.superTicketAmount) || 0);// will be optional
    const flexiprice =
      (Number(
        ticketSummary?.orderTicket?.flexiTotalTicketPrice.replace(/,/g, "")
      ) *
        100) /
      100 || 0;

    let foodPrice;
    if (localStorage.getItem("is_cvp_apply")) {
      // Convert discount price to a number
      foodPrice = Number(ticketSummary?.cvp_data?.discountPrice) || 0;
    } else {
      // Convert food prices to numbers
      foodPrice =
        Number(
          ticketSummary?.orderFood?.foods?.reduce(
            (acc, cur) => acc + cur.price * cur.quantity,
            0
          )
        ) / 100 || 0;
    }
    let price = ticketSummary?.orderTicket?.flexiApply
      ? flexiprice
      : ticketPrice;
    // Return the total price as a formatted string
    return bookingType === "BOOKING"
      ? (price + foodPrice).toFixed(2)
      : foodPrice.toFixed(2);
  };

  return (
    <>
      {loading ? (
        <BookingSummarySkeleton />
      ) : (
        <div className="all-summary p-2">
          {localStorage.getItem("booking_type") === "BOOKING" &&
            !localStorage.getItem("unpaidMode") === "true" ? (
            <ExtendTime />
          ) : (
            ""
          )}
          <div className="booking-summary show-in-desktop-view">
            <div className="book-head">
              <h3>Booking Summary</h3>
            </div>
            <div className="ticket-cancel">
              <img
                src={cancelTicket}
                alt=""
                className="img-fluid"
                onClick={() => {
                  hitCancelTicket();
                  setVisible(true);
                }}
              />
            </div>
          </div>
          {localStorage.getItem("booking_type") === "BOOKING" ? (
            <>
              <div className="movieseighteen">
                <div className="movies-summary">
                  <div className="summary-movies-photo">
                    <img
                      src={
                        ticketSummary?.orderFilmCinema?.posterVert
                          ? ticketSummary.orderFilmCinema.posterVert
                          : theme === "inoxTheme"
                            ? miv_inox
                            : miv_pvr
                      }
                      alt=""
                      onError={handleMivImageError}
                      className="img-fluid"
                      width={50}
                      height={100}
                    />
                  </div>
                  <div className="summary-movies-content">
                    <h5>{ticketSummary?.orderFilmCinema?.filmName}</h5>
                    <ul>
                      <li>{ticketSummary?.orderFilmCinema?.certificate}</li>
                      {ticketSummary?.orderFilmCinema?.genre ? (
                        <li>
                          <span className="dot-c"></span>
                          {ticketSummary?.orderFilmCinema?.genre}
                        </li>
                      ) : (
                        ""
                      )}

                      {ticketSummary?.orderFilmCinema?.language ? (
                        <li>
                          <span className="dot-c"></span>
                          {ticketSummary?.orderFilmCinema?.language}
                        </li>
                      ) : (
                        ""
                      )}
                      {ticketSummary?.orderFilmCinema?.format ? (
                        <li>
                          <span className="dot-c"></span>
                          {ticketSummary?.orderFilmCinema?.format}
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                    <p>{ticketSummary?.showTimeStr}</p>
                    <p>{ticketSummary?.orderFilmCinema?.theaterName}</p>

                  </div>
                </div>
                {ticketSummary?.adultMessage?.trim() && (
                  <div className={`adult-warning-pill ${theme === "inoxTheme" ? "adult-inox" : ""}`}>
                    <div className="adult-warning-age">
                      <span>18+</span>
                      <small>ONLY</small>
                    </div>
                    <div className="adult-warning-divider" />
                    <div className="adult-warning-text">
                      {ticketSummary?.adultMessage}
                    </div>
                  </div>
                )}
              </div>
              <div className="select-seat" style={{ display: "none" }}>
                <div className="no-seat-select">
                  <img src={cinemaScreen} alt="" className="img-fluid" />
                  <h5>No Seat Selected</h5>
                  <p>Select seats to proceed</p>
                </div>
              </div>
              {ticketSummary?.orderTicket?.seats ? (
                <div className="seat-info">
                  <h6>Seat Info</h6>
                  <p>
                    {ticketSummary?.orderTicket?.audi}
                    {ticketSummary?.orderTicket?.showClassName
                      ? " - " + ticketSummary?.orderTicket?.showClassName
                      : ""}
                  </p>
                  <div className="select-seat-number">
                    {ticketSummary?.orderTicket?.seats
                      .split(",")
                      .map((item, idx) => (
                        <div
                          className="seat-number"
                          style={
                            theme === "inoxTheme"
                              ? { backgroundColor: "#DCE2EF" }
                              : { backgroundColor: "#FFF0D6" }
                          }
                          key={idx}
                        >
                          <p>{item}</p>
                        </div>
                      ))}
                  </div>
                </div>

              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          {ticketSummary?.ph && (
            <div className="pe-holder seat-info">
              {ticketSummary?.ph.map((item, index) => (
                <a href={item?.redirectUrl || "#"} target="_blank" key={index}>
                  <img className="promotioin-placeholder" src={item?.imageUrl} alt={`Promote-earn ${index}`} />
                </a>
              ))}
            </div>
          )}
          <div className="ticket-prices">
            <>
              {ticketSummary?.orderTicket?.numOfSeats &&
                !ticketSummary?.orderTicket?.flexiApply > 0 ? (
                <>
                  <div className="ticket-summary-section p-2 seat-info">
                    <p className="text-muted mb-2" style={{ fontSize: '12px' }}>
                      {ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle
                        ? ' '
                        : 'Tickets'}
                    </p>

                    {/* If bundled offer is applied */}
                    {(ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle) && (
                      <>
                        {/* Bundled Price */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div>
                            <p className="mb-0 fw-bold text-decoration-underline">Bundled Supply</p>
                            <p className="mb-0 text-muted" style={{ fontSize: "10px" }}>
                              (Movie Ticket and F&amp;B)
                            </p>
                          </div>
                          <div className="text-end">
                            <div>
                              <span
                                className="text-danger text-decoration-line-through me-2"
                                style={{ fontSize: "13px", fontWeight: "500" }}
                              >
                                <FaRupeeSign
                                  style={{ fontSize: "12px", marginBottom: "2px" }}
                                />
                                {(
                                  Number(
                                    String(ticketSummary?.orderTicket?.totalTicketPrice || 0).replace(
                                      /,/g,
                                      ""
                                    )
                                  ) +
                                  Number(
                                    ticketSummary?.cvp_data?.actualPrice != null
                                      ? String(ticketSummary?.cvp_data?.actualPrice).replace(/,/g, "")
                                      : String(
                                        ticketSummary?.familyBundle_data?.totalPrice || 0
                                      ).replace(/,/g, "")
                                  )
                                ).toFixed(2)}
                              </span>
                              <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                <FaRupeeSign
                                  style={{ fontSize: "12px", marginBottom: "2px" }}
                                />
                                {(
                                  Number(
                                    String(ticketSummary?.orderTicket?.totalTicketPrice || 0).replace(
                                      /,/g,
                                      ""
                                    )
                                  ) +
                                  Number(
                                    ticketSummary?.cvp_data?.actualPrice != null
                                      ? String(ticketSummary?.cvp_data?.discountPrice).replace(/,/g, "")
                                      : String(
                                        ticketSummary?.familyBundle_data?.discountPrice || 0
                                      ).replace(/,/g, "")
                                  )
                                ).toFixed(2)}
                              </span>
                            </div>
                            <p className="mb-0 text-muted" style={{ fontSize: "10px" }}>
                              (Inclusive of taxes)
                            </p>
                          </div>
                        </div>

                      </>
                    )}

                    {/* Movie Ticket(s) */}
                    {!ticketSummary?.orderTicket?.cvp && !ticketSummary?.orderTicket?.familyBundle && (
                      <>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex flex-column">
                            <p style={{ fontSize: "12px" }} className={`mb-0`}>
                              Net Price ({ticketSummary?.orderTicket?.numOfSeats} <b>x</b>{" "} Ticket(s))
                            </p>
                          </div>
                          <p style={{ fontSize: "10px", fontWeight: "500" }} className={`mb-0 ${ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle ? '' : 'fw-bold'}`}>
                            <FaRupeeSign style={{ fontSize: "10px", fontWeight: "500", marginBottom: "2px" }} />
                            {ticketSummary?.orderTicket?.totalNetTicketPrice}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex flex-column">
                            <p style={{ fontSize: "12px" }} className={`mb-0`}>
                              GST
                            </p>
                          </div>
                          <p style={{ fontSize: "10px", fontWeight: "500" }} className={`mb-0 ${ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle ? '' : 'fw-bold'}`}>
                            <FaRupeeSign style={{ fontSize: "10px", fontWeight: "500", marginBottom: "2px" }} />
                            {ticketSummary?.orderTicket?.totalTicketGst}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex flex-column">
                            <p style={{ fontSize: "12px" }} className={`mb-0 ${ticketSummary?.cvp_data || ticketSummary?.orderTicket?.familyBundle ? '' : 'fw-bold'}`}>
                              Total Ticket Price
                            </p>
                          </div>
                          <p style={{ fontSize: "10px", fontWeight: "500" }} className={`mb-0 ${ticketSummary?.cvp_data || ticketSummary?.orderTicket?.familyBundle ? '' : 'fw-bold'}`}>
                            <FaRupeeSign style={{ fontSize: "10px", fontWeight: "500", marginBottom: "2px" }} />
                            {ticketSummary?.orderTicket?.totalTicketPrice}
                          </p>
                        </div>
                      </>
                    )}

                    {/* Offer Voucher from Family Bundle with Remove Button */}
                    {!ticketSummary?.orderTicket?.cvp && ticketSummary?.orderTicket?.familyBundle && (
                      <div className="mb-2 mt-1">
                        <div className="d-flex justify-content-center mt-2">
                          {/* <button
                            className="btn btn-link text-danger p-0 text-decoration-none text"
                            style={{ fontSize: "12px" }}
                            onClick={removeBundle}                          >
                            Remove Bundled Offer
                          </button> */}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}


              {/* If Comman offer is applied */}
              {ticketSummary?.orderTicket?.fnbVoucher && (
                <>
                  {/* Bundled Price */}
                  <div className="ticket-summary-section p-2 seat-info">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <p className="mb-0 fw-bold"> 1 X{" "} Food Vouchers</p>

                      </div>
                      <div className="text-end">
                        <div>
                          <span
                            className="text-danger text-decoration-line-through me-2"
                            style={{ fontSize: "13px", fontWeight: "500" }}
                          >
                            <FaRupeeSign
                              style={{ fontSize: "12px", marginBottom: "2px" }}
                            />
                            {(

                              Number(
                                ticketSummary?.cvp_data?.actualPrice != null
                                  ? String(ticketSummary?.cvp_data?.actualPrice).replace(/,/g, "")
                                  : String(
                                    ticketSummary?.familyBundle_data?.totalPrice || 0
                                  ).replace(/,/g, "")
                              )
                            ).toFixed(2)}
                          </span>
                          <span style={{ fontSize: "13px", fontWeight: "500" }}>
                            <FaRupeeSign
                              style={{ fontSize: "12px", marginBottom: "2px" }}
                            />
                            {(
                              Number(
                                ticketSummary?.cvp_data?.actualPrice != null
                                  ? String(ticketSummary?.cvp_data?.discountPrice).replace(/,/g, "")
                                  : String(
                                    ticketSummary?.familyBundle_data?.discountPrice || 0
                                  ).replace(/,/g, "")
                              )
                            ).toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                </>
              )}

              {ticketSummary?.superTicketShow && !ticketSummary?.orderTicket?.superTicket && !isSuperTicketAdded && showSuperTicketbox === 0 ? (
                <div className="st-upgrade-main-box">
                  <div className="st-exclusive-offer-container">
                    <div className="st-exclusive-offer" style={
                      theme === "inoxTheme"
                        ? {
                          backgroundColor: "#234B9E",
                          color: "#fff"
                        }
                        : {
                          backgroundColor: "#FFCB05",

                        }
                    }>
                      <img
                        src={theme === "inoxTheme" ? staricon : geminifill}
                        alt="Theme Icon"
                        className="img-fluid"
                      />
                      Exclusive Offer
                    </div>
                  </div>

                  <div className="st-upgrade-pay">
                    <div className="st-flexi-ticket-up">
                      <div className="st-small-logo-box">
                        <img src={superticketlogonew} alt="" className="img-fluid st-small-logo" />
                      </div>
                      <div className="upgrade-view-flex">
                        <p >
                          <span className="on-time">
                          </span>{" "}
                          {ticketSummary?.superTicketVoucher?.vouDesc}
                          <span className="info-flexi">
                            <img
                              src="dummy-info-flexi-img.jpg"
                              onClick={() => { }}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                        </p>
                        <p style={{ whiteSpace: "nowrap", fontWeight: 400, fontSize: "10px" }}>Validity: <span> {ticketSummary?.superTicketVoucher?.validity}</span></p>
                        <p className="st-flexi-ticket-up-p text-decoration-underline" style={{ fontWeight: 400 }}
                          onClick={() => setShowsupertickettnc(true)}>Terms & Conditions
                          {/* <img src={info} alt="" className="img-fluid" />  */}
                        </p>

                      </div>

                    </div>


                  </div>
                  <div className="st-upgrade-tc">
                    <div className="main-upgrade-terms  d-flex justify-content-between">
                      <div>
                        {/* <button
                            className="how-it-work"
                            onClick={() => setShowsupertickethowitwork(true)}>
                            How it works
                          </button> */}
                        <button
                          className="tc text-decoration-underline"
                          onClick={() => {
                            setShowsupertickethowitwork(true)
                            hitGaSuperTicket("super_ticket_know_more", ticketSummary?.superTicketVoucher?.vouId)

                          }
                          }
                        >
                          Know More
                        </button>
                      </div>
                      <div>
                        <button
                          className="upgraded-btn st-add-to-cart"
                          onClick={ApplySuperticket}
                        >
                          Add to cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {ticketSummary?.superTicketShow && ticketSummary?.orderTicket?.superTicket || isSuperTicketAdded ? (
                <div className="st-upgrade-main-box">
                  <div className="st-exclusive-offer-container">
                    <div className="st-exclusive-offer"
                      style={
                        theme === "inoxTheme"
                          ? {
                            backgroundColor: "#234B9E",
                            color: "#fff"
                          }
                          : {
                            backgroundColor: "#FFCB05",
                          }
                      }
                    >
                      <img src={theme === "inoxTheme" ? staricon : geminifill} alt="" className="img-fluid" />
                      Exclusive Offer
                    </div>
                  </div>
                  <div className="st-upgrade-pay">

                    <div className="st-flexi-ticket-up">
                      <div className="st-small-logo-box">
                        <img src={superticketlogonew} alt="" className="img-fluid st-small-logo" />
                      </div>
                      <div className="upgrade-view-flex">
                        <p>
                          <span className="on-time">
                          </span>{" "}
                          {ticketSummary?.superTicketVoucher?.vouDesc}
                          <span className="info-flexi">
                            <img
                              src="dummy-info-flexi-img.jpg"
                              onClick={() => { }}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                        </p>
                        <p style={{ whiteSpace: "nowrap", fontWeight: 400, fontSize: "10px" }}>Validity: <span> {ticketSummary?.superTicketVoucher?.validity}</span></p>
                        <p className="st-flexi-ticket-up-p text-decoration-underline" style={{ fontWeight: 200 }}
                          onClick={() => setShowsupertickettnc(true)}>Terms & Conditions
                          {/* <img src={info} alt="" className="img-fluid" />   */}
                        </p>
                      </div>
                      <div className="flexi-ticket-price">

                      </div>
                    </div>


                  </div>
                  <div className="st-upgrade-tc">
                    <div className="main-upgrade-terms  d-flex justify-content-between">
                      <div>
                        {/* <button
                      className="how-it-work"
                      onClick={() => setShowsupertickethowitwork(true)}>
                      How it works
                    </button> */}
                        <button
                          className="tc text-decoration-underline"
                          onClick={() => setShowsupertickethowitwork(true)}
                        >
                          Know More
                        </button>
                      </div>
                      <div>
                        <button className="upgraded-btn">
                          <span className="tick-upgrade">
                            <img
                              src={Tick}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                          Unlocked!
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {ticketSummary?.orderTicket?.flexiApplicable ? (
                <>
                  <div className="upgrade-main-box">
                    <div className="upgrade-pay">
                      <div className="flexi-ticket-up">
                        <div className="upgrade-view-flex">
                          <p>
                            <span className="on-time">
                              <img src={OnTime} alt="" className="img-fluid" />
                            </span>{" "}
                            Upgrade to Flexi Ticket{" "}
                            <span className="info-flexi">
                              <img
                                src={InfoFlexi}
                                onClick={() => setShowflexiHowitwork(true)}
                                alt=""
                                className="img-fluid"
                              />
                            </span>
                          </p>
                        </div>
                        <div className="flexi-ticket-price">
                          <p>
                            {ticketSummary?.orderTicket?.numOfSeats} <b>x</b>{" "}
                            <FaRupeeSign
                              style={{
                                fontSize: "10px",
                                fontWeight: "500",
                                marginBottom: "2px",
                              }}
                            />
                            {ticketSummary?.orderTicket?.flexiTicketPrice}
                          </p>
                        </div>
                      </div>
                      <p>Pay only for the time you watch, and get a refund! </p>
                    </div>
                    <div className="upgrade-tc">
                      <div className="main-upgrade-terms">
                        <div className="howto-work-flexi">
                          <button
                            className="how-it-work"
                            onClick={() => setShowflexiHiw(true)}
                          >
                            How it works
                          </button>
                          <button
                            className="tc"
                            onClick={() => setShowflexiTnc(true)}
                          >
                            T&C
                          </button>
                        </div>
                        <div className="upgrade-flexi-up">
                          {ticketSummary?.orderTicket?.flexiApply ? (
                            <>
                              <button className="upgraded-btn">
                                <span className="tick-upgrade">
                                  <img
                                    src={Tick}
                                    alt=""
                                    className="img-fluid"
                                  />
                                </span>
                                Upgraded!
                              </button>
                              <button
                                className="upgraded-btn"
                                // onClick={() => setFlexiVal(2)}
                                onClick={() => {
                                  setFlexiVal(2)
                                  hitGa("flexishow_ticket_remove");
                                }}
                                style={{
                                  color: "red",
                                  border: "1px solid red",
                                }}
                              >
                                Remove
                              </button>
                            </>
                          ) : (
                            <button
                              className="upgrade-btn"
                              // onClick={() => setFlexiVal(1)}
                              onClick={() => {
                                setFlexiVal(1)
                                hitGa("flexishow_ticket_upgrade");
                              }} >

                              Upgrade
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {ticketSummary?.orderTicket?.flexiApply ? (
                <>
                  <h6 className="pt-3">FLEXI TICKET</h6>
                  <div className="ticket-value px-2">
                    <div className="tickets-count">
                      <h6>
                        {ticketSummary?.orderTicket?.numOfSeats} <b>x</b>{" "}
                        {"FLEXI TICKET"}
                      </h6>
                    </div>
                    <div className="ticket-price">
                      <p>
                        <FaRupeeSign
                          style={{
                            fontSize: "10px",
                            fontWeight: "500",
                            marginBottom: "2px",
                          }}
                        />
                        {ticketSummary?.orderTicket?.flexiTotalTicketPrice}
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              <div className="no-snack" style={{ display: "none" }}>
                <img src={noSack} alt="" className="img-fluid" />
                <p>No snacks added</p>
              </div>
            </>

            {localStorage.getItem("is_cvp_apply") ? (
              <div className="food-beverages d-none">
                <h6>Food & BEVERAGES</h6>
                <div className="regular-food">
                  <div className="veg-food">
                    <h6>
                      {ticketSummary?.cvp_data?.quantity} X{" "}
                      {ticketSummary?.cvp_data?.quantity > 1
                        ? "VOUCHERS"
                        : "VOUCHER"}
                    </h6>
                  </div>
                  <div className="veg-price">
                    <div className="cut-price-show">
                      <h6>
                        <span className="cut-price">
                          <FaRupeeSign
                            style={{
                              fontSize: "10px",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          />
                          {parseFloat(
                            ticketSummary?.cvp_data?.actualPrice
                          ).toFixed(2)}
                        </span>
                        {"  "}
                        <span>
                          <FaRupeeSign
                            style={{
                              fontSize: "10px",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          />
                          {parseFloat(
                            ticketSummary?.cvp_data?.discountPrice
                          ).toFixed(2)}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            ) : ticketSummary?.orderFood?.foods.length > 0 ? (
              <div className="food-beverages">
                {isMobile ? (
                  <>
                    {localStorage.getItem("fnb_qr") &&
                      localStorage.getItem("booking_type") == "FOOD" ? (
                      <>
                        <h2 className="p-2 ">Pickup From Counter</h2>
                        <h3 className="p-2">
                          {ticketSummary?.orderFilmCinema?.theaterName}
                        </h3>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
                <h6>Food & BEVERAGES</h6>
                {ticketSummary?.orderFood?.foods?.map((item, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-md-8 col-9">
                      <div className="veg-food">
                        <h6>
                          <span className="nonveg-icon" style={{ marginRight: 6, float: "left" }}>
                            {item?.foodType === 1 ? (
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
                                <circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
                              </svg>
                            ) : item?.foodType === 0 ? (
                              <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.961426" y="0.964844" width="10.0769" height="10.0769" rx="1.5" stroke="#87001B" />
                                <path d="M9 8.80886H3L6.00011 3.18945L9 8.80886Z" fill="#87001B" />
                              </svg>
                            ) : (
                              <p className="emtyIcon"></p>
                            )}

                          </span>
                          {item?.name}
                        </h6>
                      </div>
                    </div>
                    <div className="col-md-4 col-3">
                      <div className="veg-price">
                        <p>
                          {item.quantity} X{" "}
                          <FaRupeeSign
                            style={{
                              fontSize: "10px",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          />
                          {item.price / 100}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}

          </div>

          {discountData && discountData?.ft ? (
            <>
              <div>
                {localStorage.getItem("unpaidMode") === "true" ? (
                  ""
                ) : (
                  <div className="applied-info">
                    <p>
                      <span>
                        <b>{applyData?.voucheName}</b>
                      </span>{" "}
                      Applied
                    </p>
                    <div className="save-remove">
                      <div className="saved-info">
                        <p>
                          <FaRupeeSign
                            style={{
                              fontSize: "10px",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          />
                          {discountData?.di} Saved
                        </p>
                      </div>
                      {applyData?.voucheName == "GIFTCARD" ||
                        applyData?.voucheName == "PASSPORT" ||
                        applyData?.voucheName == "FNBVOUCHER" ||
                        applyData?.voucheName == "SUPERTICKET" ||
                        applyData?.voucheName == "PRIVILEGE PLUS" ? (
                        ""
                      ) : (
                        <div className={`remove-text pointer ${removeLoading ? 'disabled' : ''}`} onClick={() => { setRemoveLoading(true); removevoucher(); }} >
                          <p className="mb-0">Remove</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {ticketSummary?.familyBundle_data && !isSuperTicketAdded ? (
            <>
              <div className="applied-info d-none">
                <h6>F&B Bundle Code</h6>
                <p className="save-remove">
                  <span>
                    <b>
                      {ticketSummary?.familyBundle_data?.quantity} <b>x</b>{" "}
                      {ticketSummary?.familyBundle_data?.voucherDesc}
                    </b>
                  </span>
                  <span>

                    <FaRupeeSign
                      style={{
                        fontSize: "10px",
                        fontWeight: "500",
                        marginBottom: "2px",
                      }}
                    />
                    {ticketSummary?.familyBundle_data?.discountPrice}
                  </span>
                </p>
                <div className="save-remove">
                  <div className="saved-info">
                    <p>

                    </p>
                  </div>

                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {ticketSummary?.superTicketShow && ticketSummary?.orderTicket?.superTicket || isSuperTicketAdded ? (
            <>

              <div className="applied-info st-applied-info">
                <h6>{ticketSummary?.superTicketData?.name}</h6>
                <div className="bill-amount">
                  <div className="sub-total">
                    <h6><b>{ticketSummary?.orderTicket?.numOfSeats} <b>x</b> {"Super-Tickets"}</b></h6>
                  </div>
                  <div className="tax-fees">
                    <h6>
                      <FaRupeeSign
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          marginBottom: "2px",
                        }}
                      />{" "}
                      {ticketSummary?.orderTicket?.superTicketAmount}
                    </h6>
                  </div>
                </div>
                <div
                  className="remove text-end"
                  onClick={() => {
                    RemoveSuperticket();
                  }}
                >
                  <p>Remove</p>
                </div>
              </div>

            </>
          ) : (
            ""
          )}

          <div className="bill-details">
            {(ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle) ? null : (
              <h6>BILL DETAILS</h6>
            )}
            <div className="grand-price">
              {(ticketSummary?.orderTicket?.cvp || ticketSummary?.orderTicket?.familyBundle) ? null : (
                <div className="bill-amount subtotals">
                  <div className="sub-total">
                    <h6>Sub Total</h6>
                  </div>
                  <div className="tax-fees">
                    <h6>
                      <FaRupeeSign
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          marginBottom: "2px",
                        }}
                      />{" "}
                      {calculateTotalPrice()}
                    </h6>
                  </div>
                </div>
              )}
              {ticketSummary?.orderTicket?.convTotal > 0 ? (
                <div className="bill-amounts">
                  <div className="sub-total">
                    {(ticketSummary?.cvp_data || ticketSummary?.orderTicket?.familyBundle) ? (
                      <h6>
                        Convenience Fees
                      </h6>
                    ) : (
                      <h6>
                        Taxes & Fees
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setShowConvFee(!showConvFee);
                          }}
                        >
                          <img src={priceArrow} alt="" className="img-fluid" />
                        </span>
                      </h6>
                    )}
                  </div>
                  <div className="tax-fees">
                    <h6>
                      <FaRupeeSign
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          marginBottom: "2px",
                        }}
                      />
                      {ticketSummary?.orderTicket?.convTotal}
                    </h6>
                    {(ticketSummary?.cvp_data || ticketSummary?.orderTicket?.familyBundle) && (
                      <p className="mb-0 text-muted" style={{ fontSize: "11px" }}>
                        (Inclusive of taxes)
                      </p>
                    )}
                  </div>
                </div>
              ) : null}

              {showConvFee ? (
                <>
                  <div className="bill-amounts">
                    <div className="gst">
                      <h6>Convenience Fee</h6>
                    </div>
                    <div className="tax-gst">
                      <h6>
                        <FaRupeeSign
                          style={{
                            fontSize: "10px",
                            fontWeight: "500",
                            marginBottom: "2px",
                          }}
                        />
                        {ticketSummary?.orderTicket?.conv}
                      </h6>
                    </div>
                  </div>
                  {ticketSummary?.orderFilmCinema?.hsnSacCode ? (
                    <div className="bill-amounts">
                      <div className="gst">
                        <h6>
                          (Sac Code :{" "}
                          {ticketSummary?.orderFilmCinema?.hsnSacCode})
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="bill-amounts">
                    <div className="gst">
                      <h6>GST</h6>
                    </div>
                    <div className="tax-gst">
                      <h6>
                        <FaRupeeSign
                          style={{
                            fontSize: "10px",
                            fontWeight: "500",
                            marginBottom: "2px",
                          }}
                        />
                        {ticketSummary?.orderTicket?.convGst}
                      </h6>
                    </div>
                  </div>
                  {ticketSummary?.orderFilmCinema?.stateGSTN ? (
                    <div className="bill-amounts">
                      <div className="gst">
                        <h6>GST NUMBER</h6>
                      </div>
                      <div className="tax-gst">
                        <h6>{ticketSummary?.orderFilmCinema?.stateGSTN}</h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {localStorage.getItem("booking_type") === "BOOKING" ? (
                <>
                  <div className="border-dashed"></div>
                  {donationPrice !== "0.00" ? (
                    <>
                      {localStorage.getItem("unpaidMode") === "true" ? (
                        ""
                      ) : (
                        <div>
                          <div className="cauvery-call">
                            <div className="ticket-call">
                              <h5>
                                {ticketSummary?.donationText}
                                <span className="info"></span>
                              </h5>
                            </div>
                            <div className="price-call">
                              <p>
                                <FaRupeeSign
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "500",
                                    marginBottom: "2px",
                                  }}
                                />
                                {donationPrice}
                              </p>
                            </div>
                          </div>
                          <div className="cauvery-call">
                            <div className="ticket-call">
                              {(ticketSummary?.cvp_data || ticketSummary?.orderTicket?.familyBundle) ? null : (
                                <p>
                                  <FaRupeeSign
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: "500",
                                      marginBottom: "2px",
                                    }}
                                  />
                                  {ticketSummary?.donationPrice / 100}/ticket
                                </p>
                              )}
                            </div>
                            <div className="price-call">
                              {localStorage.getItem("isOfferAppplied") ? (
                                ""
                              ) : (
                                <p
                                  className="remove"
                                  onClick={() => {
                                    getTicketSummaryData(false);
                                    localStorage.setItem("removedonationamount", true)
                                    setDonation(false);
                                    hitGa("book_remove_donation");
                                  }}
                                >
                                  Remove
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="cauvery-call">
                      {localStorage.getItem("unpaidMode") === "true" ? (
                        ""
                      ) : (
                        <div className="price-call">
                          <p
                            className="text-success pointer"
                            onClick={() => {
                              getTicketSummaryData(true);
                              localStorage.removeItem("removedonationamount");
                              setDonation(true);
                              hitGa("book_add_donation");
                            }}
                          >
                            Add Donation
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                ""
              )}

              {discountData && discountData?.ft ? (
                <>
                  <div className="sub-view rudec-view">
                    <div className="sub-total">
                      <h6>Discount</h6>
                    </div>
                    <div className="sub-price">
                      <h6 className="disc-offer">
                        -
                        <FaRupeeSign
                          style={{
                            fontSize: "10px",
                            fontWeight: "500",
                            marginBottom: "2px",
                          }}
                        />
                        {discountData?.di}
                      </h6>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {discountData && discountData?.surcharge?.length > 0 ? (
                <>
                  {discountData?.surcharge.map((item, idm) => {
                    return (
                      <div className="sub-view rudec-view">
                        <div className="sub-total">
                          <h6>
                            <span className="format-view-gap-passport">
                              {item.text}{" "}
                            </span>
                          </h6>
                        </div>
                        <div className="sub-price">
                          <h6 className="disc-offer">
                            +
                            <FaRupeeSign
                              style={{
                                fontSize: "10px",
                                fontWeight: "500",
                                marginBottom: "2px",
                              }}
                            />
                            {item.amount}{" "}
                            {discountData?.countVoucher &&
                              discountData?.countVoucher > 1
                              ? "X " + discountData?.countVoucher
                              : ""}
                          </h6>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="all-grand">
            <div className="grand-amount">
              <div className="grand-total">
                <h6>To be Paid </h6>
              </div>
              <div className="grand-prices d-flex">
                {discountData?.donation !== ticketSummary?.orderTicket?.donation ? (
                  <>
                    <h6>
                      {discountData?.ft && (
                        <span className="price-cut">
                          <FaRupeeSign style={{ fontSize: 10, fontWeight: 500, marginBottom: 2 }} />
                          {parseFloat(Number(discountData?.it.replace(/,/g, ""))).toFixed(2)}
                        </span>
                      )}
                    </h6>
                    <h6>
                      {localStorage.setItem(
                        "grandVal",
                        parseFloat(Number(ticketSummary?.totalAmount.replace(/,/g, ""))).toFixed(2)
                      )}
                      <FaRupeeSign style={{ fontSize: 10, fontWeight: 500, marginBottom: 2 }} />
                      {parseFloat(
                        Number(ticketSummary?.finalAmount.replace(/,/g, ""))
                      ).toFixed(2)}
                    </h6>
                  </>

                ) : (
                  <h6>
                    {discountData?.ft && (
                      <span className="price-cut">
                        <FaRupeeSign style={{ fontSize: 10, fontWeight: 500, marginBottom: 2 }} />
                        {parseFloat(Number(discountData?.it)).toFixed(2)}
                      </span>
                    )}{" "}
                    <FaRupeeSign style={{ fontSize: 10, fontWeight: 500, marginBottom: 2 }} />
                    {parseFloat(
                      discountData?.ft ? Number(discountData?.ft) : discountData?.totalAmount / 100
                    ).toFixed(2)}
                    {applyData?.voucheName === "PASSPORT" && (
                      <i
                        className="pi pi-info-circle"
                        onClick={() => setShowSummary(true)}
                        style={{
                          backgroundColor: theme === "inoxTheme" ? "#DCE2EF" : "#F8F6F6",
                          marginLeft: 10,
                        }}
                      />
                    )}
                  </h6>
                )}
              </div>
            </div>
          </div>
          {ticketSummary?.tnc?.trim() && isMobile && (
            <div className="summarypagecheckout">
              <div className="tnc-container">

                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <Checkbox
                      onChange={(e) => setChecked(e.checked)}
                      checked={checked}
                    />
                    <span className="tnc-label">Terms & Conditions</span>
                  </div>

                  <img onClick={() => {
                    if (typeof ticketSummary?.tnc === "string") {
                      setShowTnC(true);
                    } else {
                      setChecked(!checked);
                    }
                  }}

                    src={RightArrow} alt="arrow" className="tnc-arrow" />
                </div>

              </div>
            </div>)}
          {isMobile && ticketSummary?.orderFilmCinema?.cancelAvail && (
            <div className={`tc-card ${theme === "inoxTheme" ? "inox" : ""}`}>
              <div className="tc-ticket-icon"></div>

              <h3 className="tc-title">Now, with ticket cancellation</h3>

              <div className="tc-section">
                <div className="tc-highlight">75% Refund</div>
                <div className="tc-text">
                  until 2 hours before show time
                </div>
              </div>

              <div className="tc-section">
                <div className="tc-highlight">50% Refund</div>
                <div className="tc-text">
                  between 2 hours & 20 min <br />
                  before show start time
                </div>
              </div>

              <div className="tc-section">
                <div className="tc-highlight">100% Refund</div>
                <div className="tc-text">
                  on Food & Beverages
                </div>
              </div>
            </div>
          )}
          {ticketSummary?.cancelText &&
            (ticketSummary?.cancelAvail === false ||
              ticketSummary?.cancelAvail === "false") ? (
            <div
              className={
                theme === "inoxTheme"
                  ? "ticket-cancel-allowed-inox show-in-mobile-view"
                  : "ticket-cancel-allowed-pvr show-in-mobile-view mt-4"
              }
            >
              <p>{ticketSummary.cancelText}</p>
            </div>
          ) : null}
        </div>
      )}
      <div className="card flex justify-content-center">
        <Dialog
          visible={showAutoVoucher}
          onHide={() => setShowAutoVoucher(false)}
          showHeader={false}
          showCloseIcon={false}
          className="seat-terms-condition-flow"
          blockScroll={true}
        >
          <div className="card px-3 py-2">
            <div className="mt-3">
              <div className="d-flex justify-content-center">
                <h3>Auto Vouchers</h3>
              </div>
              <div className="d-flex justify-content-center">
                <div>
                  <ul>
                    {vouchersData &&
                      vouchersData?.map((item, idx) => {
                        return <li key={idx}>{item.vouDesc}</li>;
                      })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="accpet-btn-flow-seat">
              <DarkButton
                className="reject-terms"
                onClick={() => {
                  setShowAutoVoucher(false);
                }}
              >
                OK
              </DarkButton>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="card flex justify-content-center">
        <Dialog
          header=""
          visible={visible}
          modal={false}
          showHeader={false}
          showCloseIcon={false}
          style={{ width: "50vw" }}
          onHide={() => setVisible(false)}
          className="ticke-cancel-modal"
          blockScroll={true}
        >
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="cross-icon">
                <span
                  onClick={() => {
                    setVisible(false);
                  }}
                >
                  <i className="pi pi-times"></i>
                </span>
              </div>
              {ticketSummary?.cancelText &&
                String(ticketSummary?.cancelAvail).toLowerCase() === "false" ? (
                <>
                  <div className="ticket-terms">
                    <h4>{ticketSummary?.cancelText}</h4>
                  </div>
                </>
              ) : (
                <div className="ticket-terms">
                  <h1>Ticket Cancellation</h1>

                  <div className="refund-food">
                    <h4>
                      <span className="iconfood">
                        <img src={fastFood} alt="" className="img-fluid" />
                      </span>
                      100% Refund on F&B
                    </h4>
                  </div>

                  <div className="refund-movies">
                    <h4>
                      <span className="iconfood">
                        <img src={activity} alt="" className="img-fluid" />
                      </span>
                      Up to 75% Refund for Tickets
                    </h4>

                    <p>75% refund until 2 hours before show start time.</p>

                    <p>
                      50% refund between 2 hours and 20 minutes before show start time.
                    </p>
                  </div>

                  <div className="refund-voucher">
                    <p>
                      *Refund not available for Convenience fees, Vouchers, Gift Cards,
                      Taxes etc.
                    </p>

                    <p className="cancellation">
                      *No Cancellation within 20 minutes of show start time.
                    </p>
                  </div>

                  <div className="view-terms">
                    <Link to="/terms-conditions/booking">
                      <p>View Terms &amp; Conditions</p>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Dialog>
      </div>
      <PasssportSummary
        summary={discountData}
        showModal={showSummary}
        hideModal={setShowSummary}
      />
      <FlexiPayPopup
        visible={showflexi}
        content={ticketSummary?.content}
        setVisible={setShowflexi}
      />
      <FlexiTnc
        visible={showflexitnc}
        content={ticketSummary?.content}
        setVisible={setShowflexiTnc}
      />
      <FlexiHowItWork
        visible={showflexihiw}
        content={ticketSummary?.content}
        setVisible={setShowflexiHiw}
      />
      <FlexiHowTouse
        visible={showflexihowitwork}
        content={ticketSummary?.content}
        setVisible={setShowflexiHowitwork}
      />
      <FamilyBundle
        familyBundle={familyBundle}
        content={ticketSummary}
        setFamilyBundle={setFamilyBundle}
        ticketSummaryCalled={setTicketSummaryFb}
      />
      <SuperTicketHowItWork
        visible={showsupertickethowitwork}
        content={ticketSummary?.superTicketData}
        setVisible={setShowsupertickethowitwork}
      />
      <SuperTicketTnc
        visible={showsupertickettnc}
        content={ticketSummary?.superTicketData}
        setVisible={setShowsupertickettnc}
      />
      <SuperTicketRules
        visible={showsuperticketrules}
        content={ticketSummary?.superTicketData}
        setVisible={setShowsuperticketrules}
      />
      <Dialog
        visible={showTnC}
        onHide={() => setShowTnC(false)}
        showHeader={false}
        position="bottom"
        showCloseIcon={false}
        className="seat-terms-condition-flow"
        blockScroll={true}
      >
        <div className="card px-3 py-2">
          <div className="mt-3">
            <div className="d-flex justify-content-center">
              <h3>Terms & Conditions</h3>
            </div>
            <div className="seatlayout-tnc mt-3 mx-3">
              {ticketSummary?.tnc ? (
                <HtmlRenderer html={ticketSummary?.tnc} />
              ) : (
                <div className="terms-conditins-flowseat"></div>
              )}
            </div>
          </div>
          <div className="accpet-btn-flow-seat">
            <DarkButton
              className="reject-terms"
              onClick={() => {
                setChecked(true);
                setShowTnC(false);
              }}
            >
              Accept
            </DarkButton>
          </div>
        </div>
        {/* <ReactPlayer controls playing={true} url={mtrailerurl} /> */}
      </Dialog>

    </>
  );
};

export default TicketSummary;
